import { ConfirmationApproveReactivateIcon, UnsuspendIcon } from "@/assets";
import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { ToastMessage, type } from "@/lib/toastr";
import { unSuspendUser } from "@/services/Users.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";

const Unsuspend = ({ name, id }) => {
  const queryClient = useQueryClient();

  const [step, setStep] = useState(1);
  const mutation = useMutation({
    mutationFn: async (payload) => await unSuspendUser(id, payload),
    mutationKey: ["unsuspend"],

    onSuccess: (res) => {
      setStep(2);
      queryClient.invalidateQueries("user");
      queryClient.invalidateQueries("bank");

      ToastMessage(type.SUCCESS, "Customer successfully unsuspended");
    },
    onError: (err) => {
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });

  const form = useForm();

  const onSubmit = async (formData) => {
    await mutation.mutate(formData);
  };
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="flex flex-col items-center justify-center w-full gap-10 p-8">
          <div className="flex flex-col w-full gap-9">
            <DialogHeader className="flex flex-col items-center gap-4 text-center text-green-3 ">
              {step == 1 ? (
                <UnsuspendIcon />
              ) : (
                <ConfirmationApproveReactivateIcon />
              )}
              <div className="flex flex-col gap-2">
                <DialogTitle className="text-center">
                  {step == 1
                    ? "UnSuspend This User?"
                    : "User Successfully Unblocked!"}
                </DialogTitle>
                <DialogDescription className="text-center">
                  {step == 1
                    ? "Are you sure you want to unblock this user?"
                    : `${name} was successfully unblocked from the Treasura platform`}
                </DialogDescription>
              </div>
            </DialogHeader>

            {step === 1 && (
              <FormField
                control={form.control}
                name="reason"
                render={({ field }) => {
                  return (
                    <FormItem>
                      <div className="flex flex-col w-full items-star   gap-1.5 border-[1px]  rounded-[8px] px-2 py-2 h-full border-input-border ">
                        <FormLabel htmlFor="message" className="text-xs">
                          Reason for Rejection
                        </FormLabel>
                        <FormControl>
                          <Textarea
                            placeholder="Type your message here."
                            className="w-full p-0 border-none ring-transparent focus-visible:ring-transparent"
                            {...field}
                          />
                        </FormControl>
                      </div>
                    </FormItem>
                  );
                }}
              />
            )}
          </div>
          <div className="flex flex-col items-center w-full ">
            {step == 1 ? (
              <>
                <Button
                  type="submit"
                  className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] w-full"
                  disabled={mutation.isPending}
                >
                  {mutation.isPending && <Loader2 className="animate-spin" />}
                  Yes, I want to unblock this user <ChevronRight />
                </Button>
                <DialogClose asChild>
                  <Button type="button" variant="ghost">
                    No, I want to cancel
                  </Button>
                </DialogClose>
              </>
            ) : (
              <DialogClose asChild onClick={() => setStep(1)}>
                <Button className="flex justify-center items-center bg-off-white-2 h-12 rounded-[10px] w-full text-gray">
                  <ChevronLeft /> Back to users
                </Button>
              </DialogClose>
            )}
          </div>
        </div>
      </form>
    </Form>
  );
};

export default Unsuspend;
